<div
  class="px-3 py-2.5"
  [ngClass]="
    selected()
      ? 'bg-primary-soft dark:bg-primary-soft-darkmode'
      : 'bg-surface-magic dark:bg-surface-magic-darkmode'
  "
>
  <ui-checkbox-label>
    <ui-checkbox [checked]="selected()" [disabled]="isDisabled()" />
    <ng-content />
  </ui-checkbox-label>
</div>
